import { useEffect } from 'react';

/**
 * A single acid-tinted glow that follows the cursor (client-only, one rAF, no
 * React state). Disabled for reduced-motion and coarse pointers via CSS.
 */
export const CursorSpotlight = () => {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    if (window.matchMedia('(pointer: coarse)').matches) return undefined;

    const el = document.createElement('div');
    el.id = 'cursor-spot';
    document.body.appendChild(el);

    let x = 0;
    let y = 0;
    let raf = 0;
    let shown = false;

    const apply = () => {
      raf = 0;
      el.style.transform = `translate(${x}px, ${y}px)`;
    };
    const onMove = (e: PointerEvent) => {
      x = e.clientX;
      y = e.clientY;
      if (!shown) {
        shown = true;
        el.style.opacity = '1';
      }
      if (!raf) raf = requestAnimationFrame(apply);
    };

    window.addEventListener('pointermove', onMove, { passive: true });
    return () => {
      window.removeEventListener('pointermove', onMove);
      if (raf) cancelAnimationFrame(raf);
      el.remove();
    };
  }, []);

  return null;
};
